import { createContext } from 'react';
import { Nullable } from 'common/types/nullable';
import { RowCountValue } from './types';

/** React context for row count provider. */
const RowCountContext = createContext<Nullable<RowCountValue>>(null);
export default RowCountContext;
